import { useState } from "react";
import { DataTable } from "../../components/organisms/DataTable";
import { paginacion } from "../../utils/paginacion/paginacion";

const REGISTROS_POR_PAGINA = 15;

export const EstudianteDescongelarList = ({
  registros = [],
  onActualizarEstado,
  freezeTypes,
  setFreezeTypes,
  onAsignarModulo,
}) => {
  const [paginaActual, setPaginaActual] = useState(1);

  const {
    objetosEnPagina: registrosEnPagina,
    paginas,
    paginaInicial,
    paginaFinal,
  } = paginacion(paginaActual, registros, REGISTROS_POR_PAGINA);

  const columnas = [
    "#",
    "Estudiante",
    "Estado",
    "Tipo de Admision",
    "Tipo de Congelación",
    "Acciones",
  ];

  const mostrarRegistros = registrosEnPagina.length > 0;

  const esCongelado = (tipo) =>
    ["voluntario", "institucional"].includes(tipo?.trim().toLowerCase());

  return (
    <DataTable
      columnas={columnas}
      paginas={paginas}
      paginaInicial={paginaInicial}
      paginaFinal={paginaFinal}
      paginaActual={paginaActual}
      setPaginaActual={setPaginaActual}
    >
      {mostrarRegistros ? (
        registrosEnPagina.map((reg, i) => {
          const {
            idRegistro,
            estudiante = {},
            estado,
            tipoCongelacion = "",
            estaCongelado,
          } = reg;

          const {
            nombre = "",
            apellido = "",
            tipoAdmi = "Desconocido",
          } = estudiante;

          const freezeTypeSelected = freezeTypes[idRegistro] || "";

          return (
            <tr
              key={idRegistro}
              className="bg-white hover:bg-gray-100 transition-colors duration-300 [&>td]:p-3 [&>td]:text-gray-700 [&>td]:whitespace-nowrap border-b border-slate-200"
            >
              <td className="font-medium border-r border-slate-200 border-t">
                {(paginaActual - 1) * REGISTROS_POR_PAGINA + i + 1}
              </td>
              <td className="border-r border-slate-200 border-t">{`${nombre} ${apellido}`}</td>
              <td className="border-r border-slate-200 border-t">{estado}</td>
              <td className="border-r border-slate-200 border-t">{tipoAdmi}</td>
              <td className="border-r border-slate-200 border-t">{tipoCongelacion}</td>
              <td className="px-2 py-2 text-sm">
                <div className="flex flex-wrap gap-2 justify-start">
                  {estaCongelado ? (
                    <button
                      onClick={() => onActualizarEstado(idRegistro, false, null)}
                      className="bg-blue-600 hover:bg-blue-700 text-white text-sm px-5 py-2 rounded shadow"
                    >
                      Descongelar
                    </button>
                  ) : (
                    <>
                      <select
                        className="text-sm px-3 py-2 border rounded"
                        value={freezeTypeSelected}
                        onChange={(e) =>
                          setFreezeTypes((prev) => ({
                            ...prev,
                            [idRegistro]: e.target.value,
                          }))
                        }
                      >
                        <option value="">-- Seleccionar --</option>
                        <option value="Voluntario">Congelar (Vol)</option>
                        <option value="Institucional">Congelar (Inst)</option>
                      </select>
                      <button
                        onClick={() =>
                          onActualizarEstado(idRegistro, true, freezeTypeSelected)
                        }
                        className="bg-green-500 hover:bg-green-600 text-white text-sm px-5 py-2 rounded shadow"
                      >
                        Aplicar
                      </button>
                    </>
                  )}

                  <button
                    onClick={() => onAsignarModulo(reg)}
                    className={`text-sm font-semibold py-2 px-4 rounded shadow ${
                      esCongelado(tipoCongelacion)
                        ? "bg-gray-400 cursor-not-allowed text-white"
                        : "bg-theme-yellow hover:bg-yellow-500 text-white"
                    }`}
                  >
                    Asignar módulo
                  </button>
                </div>
              </td>
            </tr>
          );
        })
      ) : (
        <tr>
          <td colSpan={columnas.length} className="text-center py-4">
            No hay datos o no coincide con la búsqueda.
          </td>
        </tr>
      )}
    </DataTable>
  );
};